import LoteService from "services/LoteService";
import { BUSCA_ENTREVERO } from "redux/actions/actionsConstants";
import trataErroGenerico from "lib/trataErroGenerico";
import { calcularSaldoDeEntreveroPorLote } from "features/manejo/views/MenuLateral/Farol/FarolUtils";

function trataErro(dispatch, error) {
  trataErroGenerico(
    dispatch,
    error,
    "Ocorreu um erro ao buscar informação dos lotes",
    "",
    "Ocorreu um erro ao buscar informação dos lotes"
  );
}

export const buscaLotesEntrevero = () => async (dispatch, getState) => {
  const { fazenda } = getState();
  try {
    const lotesRetornados = await LoteService.obtemLotesEntrevero(
      fazenda.FazendaSelecionada
    );

    const saldoDeEntreveroPorLote = calcularSaldoDeEntreveroPorLote(
      lotesRetornados.data
    );

    dispatch({
      type: BUSCA_ENTREVERO,
      payload: {
        lotesComEntrevero: lotesRetornados.data,
        saldoDeEntreveroPorLote,
      },
    });
  } catch (error) {
    dispatch({
      type: BUSCA_ENTREVERO,
      payload: {
        lotesComEntrevero: [],
        saldoDeEntreveroPorLote: {},
      },
    });
    trataErro(dispatch, error);
  }
};
